import { BOARD_COLUMN_GAP, BOARD_COLUMN_WIDTH } from '../constants.tsx';

export const getSwimlanesBoardWidth = (columnsCount: number) =>
	columnsCount * (BOARD_COLUMN_WIDTH + BOARD_COLUMN_GAP) - BOARD_COLUMN_GAP;
